import React, { useState, useEffect } from 'react';

const CommentModal = ({ reelId, onClose, api }) => {
  const [comments, setComments] = useState([]);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (reelId) fetchComments();
  }, [reelId]);

  const fetchComments = async () => {
    try {
      const res = await api.get(`/reels/${reelId}/comments`);
      if (res.data.success) setComments(res.data.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const submitComment = async () => {
    if (!text.trim()) return;
    setSending(true);
    try {
      await api.post(`/reels/${reelId}/interact`, { type: 'comment', comment_text: text });
      setText('');
      setLoading(true);
      fetchComments();
    } catch (e) { console.error(e); }
    finally { setSending(false); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center" onClick={onClose}>
      <div className="absolute inset-0 bg-black/60" />
      <div className="relative bg-gray-900 rounded-t-2xl w-full max-w-lg max-h-[70vh] flex flex-col"
        onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-800">
          <h3 className="text-lg font-semibold text-light">Comments</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-light text-xl">✕</button>
        </div>

        {/* Comments list */}
        <div className="flex-1 overflow-y-auto p-4 space-y-3">
          {loading ? (
            <div className="text-center py-8 text-gray-500">Loading comments...</div>
          ) : comments.length === 0 ? (
            <div className="text-center py-8 text-gray-500">No comments yet</div>
          ) : (
            comments.map(c => (
              <div key={c._id} className="flex gap-3">
                <div className="w-8 h-8 rounded-full bg-gold/30 flex items-center justify-center text-gold font-bold text-xs flex-shrink-0">
                  {c.user_id?.name?.charAt(0) || '?'}
                </div>
                <div className="flex-1">
                  <p className="text-sm text-light font-medium">{c.user_id?.name || 'Anonymous'}</p>
                  <p className="text-sm text-gray-300">{c.comment_text}</p>
                  <p className="text-xs text-gray-500 mt-0.5">{new Date(c.createdAt).toLocaleDateString()}</p>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Input */}
        <div className="p-4 border-t border-gray-800 flex gap-2">
          <input type="text" value={text} onChange={e => setText(e.target.value)}
            placeholder="Write a comment..."
            className="flex-1 bg-gray-800 text-light border border-gray-600 rounded-lg px-3 py-2 text-sm"
            onKeyDown={e => e.key === 'Enter' && submitComment()} />
          <button onClick={submitComment} disabled={sending || !text.trim()}
            className="bg-gold text-dark px-4 py-2 rounded-lg font-semibold text-sm disabled:opacity-50">
            {sending ? '...' : 'Send'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommentModal;
